import CampaignCreationBrandSelection from 'Components/campaigns/create-edit/BrandSelection';
import CampaignCreationAIBrief from 'Components/campaigns/create-edit/CampaignCreationAIBrief';
import ifConfigured from 'hoc/ifConfigured';
import React, { useState } from 'react'
import { UserBrand } from 'types/users';

const CreateCampaignAIBrief = () => {
    const [selectedBrand, setSelectedBrand] = useState<UserBrand | null>(null);


    if (!selectedBrand) {
        return <CampaignCreationBrandSelection mode='prompt' value={selectedBrand} onChange={setSelectedBrand} />
    }

    return (
        <>
            {selectedBrand && (
                <CampaignCreationAIBrief
                    key={selectedBrand.social_account?.uuid ?? ''}
                    brandSocialAccountId={selectedBrand.social_account?.uuid ?? ''}
                    onBrandChange={setSelectedBrand}
                />
            )}

        </>
    )
}

export default ifConfigured(CreateCampaignAIBrief, 'agency_ai_campaign_allowed', '/campaign/create')